import Image from "next/image";
import battlefield from "public/images/battlefield.jpg";
import crusade from "public/images/Crusade.png";
import playlogo from "public/images/playlogosmall.png";
import wild from "public/images/WildfireArt.jpg";

import {
  DoomLayoutSection,
  ExternalLink,
  H3,
  InternalLink,
  Line,
  P,
  useBreakpoints,
} from "@sorcery/ui";

import { formatsPath, locatorPath, registerStorePath } from "~/utils/paths";

export const BecomeARetailerEventsTab = () => {
  const { isLg } = useBreakpoints();
  return (
    <div className="duration-1000 animate-in fade-in">
      <ExternalLink href={registerStorePath} target="_blank">
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={battlefield}
            darken={!isLg}
            gradient={false}
            smooshRight
            animateRight={false}
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <div className="w-full">
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
                  Sorcery Play Network
                </H3>
                <Line className="mb-1" />
                <Line className="mb-4" />

                <P>
                  Register your store on the Sorcery Play Network to appear on our global store
                  locator and run events. Your store now welcomes Sorcerers to your Contested
                  Realm...
                </P>
              </div>
            }
            right={
              <div>
                <Image src={playlogo} alt={"Play Network"} />
              </div>
            }
          />
        </div>
      </ExternalLink>

      <InternalLink href={locatorPath}>
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={crusade}
            darken={!isLg}
            gradient={false}
            smooshRight
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <div className="w-full">
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
                  Store Locator
                </H3>
                <Line className="mb-1" />
                <Line className="mb-4" />

                <P>
                  Help potential Sorcerers find you. Register your store to appear amongst the
                  global network of Sorcery retailers.
                </P>
              </div>
            }
            right={<div className="h-12" />}
          />
        </div>
      </InternalLink>

      <InternalLink href={formatsPath}>
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={wild}
            darken={!isLg}
            gradient={false}
            smooshRight
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <div className="w-full">
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
                  Formats
                </H3>
                <Line className="mb-1" />
                <Line className="mb-4" />

                <P>
                  Explore a myriad of Sorcery formats. From kitchen table chaos, all the way up to
                  competitive constructed, host events of any kind for your community to battle it
                  out for supremacy.
                </P>
              </div>
            }
            right={<div className="h-12" />}
          />
        </div>
      </InternalLink>
    </div>
  );
};
